import { Checkbox, Field, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWithWorksheetInjectedProps, WorksheetEquipmentDropdown } from 'Components/Worksheets//Core';
import { hasNonEmptyValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';
import AsLiquidLimitApparatusChecksSection from './LiquidLimitApparatusChecksSection';

let LiquidLimitEquipmentDetailsSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const groovingToolId = useSelector(createWorksheetSelector!('GroovingTool.Id'));
  const groovingToolType = useSelector(createWorksheetSelector!('GroovingToolType'));
  const groovingToolShape = useSelector(createWorksheetSelector!('GroovingToolShape'));
  const groovingToolImportMismatch = useSelector(createWorksheetSelector!('GroovingToolImportMismatch'));

  const LiquidLimitApparatusImportMismatch = useSelector(
    createWorksheetSelector!('LiquidLimitApparatusImportMismatch')
  );
  const LiquidLimitEquipment = useSelector(createWorksheetSelector!(`LiquidLimitApparatus`), deepEquals);
  const LiquidLimitId = useSelector(createWorksheetSelector!('LiquidLimitApparatus.Id'));
  const liquidLimitDeviceType = useSelector(createWorksheetSelector!('ApparatusType'));
  return (
    <>
      <ListFieldSection heading="Equipment Details">
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="Liquid Limit Apparatus"
          equipmentType="liquid-limit-apparatus"
          name="LiquidLimitApparatus"
          importedAdditionalData={{
            DeviceType: liquidLimitDeviceType,
            Mismatch: LiquidLimitApparatusImportMismatch,
          }}
          importModel={{ Id: LiquidLimitEquipment && LiquidLimitEquipment.Id }}
        />
        {hasNonEmptyValue(LiquidLimitId) ? (
          <>
            <Field input={<TextOutput />} label="Liquid Limit Apparatus type" name="ApparatusType" />
          </>
        ) : (
          <>
            <Field
              input={<RadioGroup />}
              label="Liquid Limit Apparatus type"
              name="ApparatusType"
              options={[
                { label: 'Manual', value: 'Manual' },
                { label: 'Mechanical', value: 'Mechanical' },
              ]}
            />
          </>
        )}
        <AsLiquidLimitApparatusChecksSection />
      </ListFieldSection>

      <ListFieldSection>
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="Grooving Tool"
          equipmentType="grooving-tool"
          name="GroovingTool"
          importedAdditionalData={{
            GroovingToolType: groovingToolType,
            GroovingToolShape: groovingToolShape,
            Mismatch: groovingToolImportMismatch,
          }}
          importModel={{ Id: groovingToolId }}
        />
        {hasNonEmptyValue(groovingToolId) ? (
          <>
            <Field input={<TextOutput />} label="Grooving Tool Shape" name="GroovingToolShape" />
          </>
        ) : (
          <>
            <Field
              input={<RadioGroup />}
              label="Grooving Tool Shape"
              name="GroovingToolShape"
              options={[
                { label: 'Flat', value: 'Flat' },
                { label: 'Curved', value: 'Curved' },
              ]}
            />
          </>
        )}
        <Field input={<Checkbox />} name="GroovingToolWidthCheck" />
      </ListFieldSection>
    </>
  );
};

LiquidLimitEquipmentDetailsSection = withInjectedProps(LiquidLimitEquipmentDetailsSection);

export { LiquidLimitEquipmentDetailsSection };
export default LiquidLimitEquipmentDetailsSection;
